import React, { useState, useEffect } from 'react';
import { useOnline } from '../hooks/useOnline';

const OfflineBanner = () => {
  const online = useOnline();
  const [dismissed, setDismissed] = useState(false);

  // Reset dismiss when connection comes back so banner reappears on next offline.
  useEffect(() => {
    if (online) setDismissed(false);
  }, [online]);

  if (online || dismissed) return null;

  return (
    <div
      className="sticky top-0 z-40 bg-amber-50 dark:bg-amber-950/80 border-b-3 border-fun-lemon"
      role="alert"
      aria-live="polite"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <span className="text-xl" role="img" aria-hidden="true">📵</span>
            <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
              Offline — reading from cache; your changes will sync when you&apos;re back online
            </p>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="p-1 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/40 rounded-clay transition-colors"
            aria-label="Dismiss offline banner"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfflineBanner;
